import React, { Component } from 'react'
import { Button, Checkbox, Container, FormControlLabel, TextField } from '@material-ui/core'
import ReactDOM from 'react-dom'
import GoogleLogin, { GoogleLogout } from 'react-google-login'
import AuthenticationApi from '../api/authenticationApi'
import ErrorBoundary from '../common/errorBoundary'
import * as timexHelper from '../common/helper'
import LocalStorageHelper from '../common/localStorageHelper'
import * as config from '../data/config'
import GoogleLogo from '../assets/images/google-g-logo.png'
import { ReactComponent as Logo } from '../assets/images/ftp_loader.svg';

import '../style/main.scss';
import './login.scss';

const clientId = '468320588187-juknin8rgfue4cmgle5i6aj1enomr3ch.apps.googleusercontent.com';

export default class Login extends Component {
  constructor(props) {
    super(props);

      this.state = {
          //rememberMe: true,
          isLoggedin: false,
          user: null,
          error: ''
      };
    }

    componentDidMount = () => {
        if (timexHelper.IsLoggedIn()) {
            let user = LocalStorageHelper.getUser();
            let token = '';
            if (user && user.token) {
                token = user.token;
            }
            //debugger;            
            let isValid = AuthenticationApi.validateToken(token);
            if (isValid) {
                this.setState({ isLoggedin: true, user: user });
                this.props.onLoginChange(true, user);
            } else {
                LocalStorageHelper.removeUser();
            }
        }
    }

    responseGoogle = (response) => {
        if (response.tokenId) {
            let user = {
                token: response.tokenId
            };
            if (response.profileObj) {
                if (response.profileObj.imageUrl) {
                    user.avatarUrl = response.profileObj.imageUrl;
                }
                if (response.profileObj.email) {
                    user.email = response.profileObj.email;
                }
            }
            this.setState({ isLoggedin: true, user: user, error: '' });
            this.props.onLoginChange(true, user);
            LocalStorageHelper.setUser(user);
            this.props.history.push('/');
        }
        if (response.error) {
            this.setState({ error: response.error });
        }
    }

    logout = (response) => {
        LocalStorageHelper.removeUser();
        this.setState({ isLoggedin: false, user: null });
        this.props.onLoginChange(false, null);
        AuthenticationApi.logOut(this.state.user?.token);
    }

  handleChange = event => {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      this.setState({
          [name]: value
      });
  }

  render() {

    return (
        <ErrorBoundary>
            <Container maxWidth="sm">
            <div className="floatLeft logo"><Logo />    </div>
                <div className="clear"></div>
                <div style={{ marginTop: '11em' }}>
                    <div className="center">
                        <br />
                        <img src={GoogleLogo} alt="Google" width="100" />
                        <br />
                        <br />
                        {(this.state.isLoggedin && this.state.user) ?
                            // Logged in
                            <div className="login-text">
                                <div>
                                    <img src={this.state.user.avatarUrl} width="96" />
                                </div>
                                <br />
                                <div>Logged in as: {this.state.user.email}</div>
                                <br />
                                <GoogleLogout
                                    clientId={clientId}
                                    buttonText="Logout"
                                    onLogoutSuccess={this.logout}
                                >
                                </GoogleLogout>
                            </div>
                            :
                            // Not logged in
                            <div>
                                <div>
                                    <GoogleLogin
                                        clientId={clientId}
                                        buttonText="Login"
                                        onSuccess={this.responseGoogle}
                                        onFailure={this.responseGoogle}
                                        cookiePolicy={'single_host_origin'}
                                        className='google'
                                    />
                                </div>
                                {/*<FormControlLabel
                                    className="remember-me"
                                    control={
                                        <Checkbox
                                            name="rememberMe"
                                            checked={this.state.rememberMe}
                                            onChange={this.handleChange}
                                            color="primary"
                                        />
                                    }
                                    label="Remember Me"
                                />*/}
                            </div>
                        }
                        {/* { this.state.error ?
                            <div className="login-error">{this.state.error}</div> : null } */}
                        <br />
                    </div>
                </div>
            </Container>
        </ErrorBoundary>
    );
  }
}
